import { Component, OnInit } from '@angular/core';
import {FormControl} from "@angular/forms";
import {map, Observable, startWith} from "rxjs";

import {Customer, GrantComponent, Settings} from "../../../core/models";
import {ActivatedRoute} from "@angular/router";
import {FormGroup} from "@angular/forms";
import {CustomersService} from "../../../core/services";
import {fadeIn, fadeOut} from "../../../core/animations/fadeInAnimation";

@Component({
    selector: 'app-customer-settings',
    templateUrl: './customer-settings.component.html',
    styleUrls: ['./customer-settings.component.scss'],
    standalone: false,
    animations: [fadeIn, fadeOut]
})
export class CustomerSettingsComponent implements OnInit {

  customer: Customer;
  components: GrantComponent[];

  searchControl = new FormControl('', {nonNullable: true});
  settingsList = [
    { key: 'journal_no', label: 'Journalnummer', category: 'Generelt & Administration' },
    { key: 'profile', label: 'Profil', category: 'Generelt & Administration' },
    { key: 'case-workers', label: 'Sagsbehandler', category: 'Generelt & Administration' },
    { key: 'custom-value', label: 'Primærværdi', category: 'Generelt & Administration' },
    { key: 'history', label: 'Historik', category: 'Generelt & Administration' },

    { key: 'dialog', label: 'Dialog', category: 'Kommunikation & Support' },
    { key: 'comments', label: 'Fælles Kommentarer', category: 'Kommunikation & Support' },
    { key: 'sms', label: 'SMS', category: 'Kommunikation & Support' },
    { key: 'smtp', label: 'Mail', category: 'Kommunikation & Support' },
    { key: 'support', label: 'Support', category: 'Kommunikation & Support' },

    { key: 'payments', label: 'Betalinger', category: 'Økonomi & Jura' },
    { key: 'accounting', label: 'Regnskab/Kontoplan', category: 'Økonomi & Jura' },
    { key: 'gdpr', label: 'GDPR-indstillinger', category: 'Økonomi & Jura' },

    { key: 'authentication', label: 'Login', category: 'Sikkerhed & Adgang' },
    { key: 'security', label: 'Sikkerhed', category: 'Sikkerhed & Adgang' },
    { key: 'export_project_logs', label: 'Eksport af handlingslogs', category: 'Sikkerhed & Adgang' },

    { key: 'overview_xlsx', label: 'Økonomi / Overblik', category: 'Data & Rapportering' },
    { key: 'import', label: 'Import indstillinger', category: 'Data & Rapportering' },
    { key: 'materialized_view', label: 'Søgning og periode', category: 'Data & Rapportering' },
    { key: 'extra-columns', label: 'Søjler', category: 'Data & Rapportering' },

    { key: 'votes', label: 'Stemmefordeling', category: 'Specialiserede funktioner' },
    { key: 'siblings', label: 'Søsterfonde', category: 'Specialiserede funktioner' },
    { key: 'warnings', label: 'Advarsler', category: 'Specialiserede funktioner' }
  ];

  categories = [
    'Generelt & Administration',
    'Kommunikation & Support',
    'Økonomi & Jura',
    'Sikkerhed & Adgang',
    'Data & Rapportering',
    'Specialiserede funktioner'
  ];

  filteredSettings$: Observable<string[]>;

  constructor(private route: ActivatedRoute,
              private customersService: CustomersService) { }

  ngOnInit(): void {
    this.loadCustomer();
    this.filteredSettings$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterSettings(value))
    );
  }

  private filterSettings(value: string): string[] {
    const filterValue = value.toLowerCase();
    const filtered = this.settingsList
      .filter(setting => setting.label.toLowerCase().includes(filterValue))
      .map(setting => setting.key);

    // Auto-expand if only one result
    if (filtered.length === 1) {
      // Note: Auto-expansion logic was removed as the 'expanded' input is no longer used
    }

    return filtered;
  }

  isVisible(key: string, visibleKeys: string[] | null): boolean {
    if (!visibleKeys) return true;
    return visibleKeys.includes(key);
  }

  hasVisibleSettingsInCategory(category: string, visibleKeys: string[] | null): boolean {
    if (!visibleKeys) return true;
    return this.settingsList
      .filter(s => s.category === category)
      .some(s => visibleKeys.includes(s.key));
  }

  loadCustomer(): void {
    this.route.data.subscribe(data => {
      this.customer = data['customer'];
    })
  }

  save(slug: string, settingsGroup: FormGroup | Record<string, unknown>): void {
    const settingsData = settingsGroup instanceof FormGroup ? settingsGroup.value : settingsGroup;
    const settings: Settings = Object.assign({}, this.customer.settings, {[slug]: settingsData});
    const customer: Customer = Object.assign({}, this.customer, { settings });
    this.customersService.update(customer)
      .subscribe(value => {
        this.customer = value;
      });
  }
}
